<template>
  <div class="search-by-date">
    <vs-row>
      <vs-col>
        <h6 v-if="showInitialDate">Busque por intervalo</h6>
        <h6 v-else>Busque pelo final do período</h6>
      </vs-col>
    </vs-row>
    <vs-row v-if="centerAlign" vs-justify="center" vs-align="flex-start">
      <vs-col
        v-if="showInitialDate"
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-input
          type="date"
          label="De"
          class="w-full"
          v-model="date.initial"
          max="9999-12-30"
          :danger="invalidFields.dateInitial"
        />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        :vs-lg="showInitialDate ? 6 : 8"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-input
          type="date"
          label="Até"
          class="w-full"
          v-model="date.final"
          max="9999-12-30"
          :danger="invalidFields.dateFinal"
          danger-text="A data deve ser superior a inicial"
        />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-lg="1"
        vs-sm="12"
        vs-xs="12"
        v-if="showSearchButton || showClearFields"
      >
        <vx-tooltip
          text="Clique para filtrar a busca pelo intervalo de tempo inserido."
          v-if="showSearchButton"
        >
          <vs-button
            v-bind:disabled="disabledSearchButton"
            class="search"
            color="warning"
            type="border"
            icon="icon-search"
            icon-pack="feather"
            @click="sendDate"
          />
        </vx-tooltip>
        <vx-tooltip
          text="Clique para remover o intervalo de tempo."
          v-if="showClearFields"
        >
          <vs-button
            class="search clear"
            color="warning"
            type="border"
            icon="clear"
            @click="clearFields"
          />
        </vx-tooltip>
      </vs-col>
    </vs-row>

    <vs-row v-else vs-justify="flex-start" vs-align="flex-start">
      <vs-col
        v-if="showInitialDate"
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-lg="5"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-input
          type="date"
          label="De"
          class="w-full"
          v-model="date.initial"
          max="9999-12-30"
          :danger="invalidFields.dateInitial"
        />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        :vs-lg="showInitialDate ? 5 : 8"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-input
          type="date"
          label="Até"
          class="w-full"
          v-model="date.final"
          max="9999-12-30"
          :danger="invalidFields.dateFinal"
          danger-text="A data deve ser superior a inicial"
        />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-lg="1"
        vs-sm="12"
        vs-xs="12"
        v-if="showSearchButton || showClearFields"
      >
        <vx-tooltip
          text="Clique para filtrar a busca pelo intervalo de tempo inserido."
          v-if="showSearchButton"
        >
          <vs-button
            v-bind:disabled="disabledSearchButton"
            class="search"
            color="warning"
            type="border"
            icon="icon-search"
            icon-pack="feather"
            @click="sendDate"
          />
        </vx-tooltip>
        <vx-tooltip
          text="Clique para remover o intervalo de tempo."
          v-if="showClearFields"
        >
          <vs-button
            class="search clear"
            color="warning"
            type="border"
            icon="clear"
            @click="clearFields"
          />
        </vx-tooltip>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import mixins from "@/Mixins.js";

export default {
  mixins: [mixins],
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      invalidFields: {
        dateFinal: false,
        dateInitial: false,
      },
      disabledSearchButton: true,
    };
  },
  props: {
    date: {
      type: Object,
      required: false,
      default() {
        return {
          initial: null,
          final: null,
        };
      },
    },
    showClearFields: {
      type: Boolean,
      default: true,
      required: false,
    },
    allowOnlyFinalDate: {
      type: Boolean,
      default: false,
      required: false,
    },
    showInitialDate: {
      type: Boolean,
      default: true,
      required: false,
    },
    showSearchButton: {
      type: Boolean,
      default: true,
      required: false,
    },

    centerAlign: {
      type: Boolean,
      default: false,
      required: false,
    },

    centerJustify: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  watch: {
    "date.initial": function () {
      const vm = this;
      vm.validateDates();
    },
    "date.final": function () {
      const vm = this;
      vm.validateDates();
    },
  },

  methods: {
    validateDates() {
      const vm = this;

      const result = vm.validateDateFields(vm.date.initial, vm.date.final);
      vm.invalidFields.dateInitial = result.invalidInitial;
      vm.invalidFields.dateFinal = result.invalidFinal;
      vm.disabledSearchButton = result.disableButton;

      if (
        !vm.showClearFields &&
        (vm.testNullUndefinedEmpty(vm.date.initial) ||
          vm.testNullUndefinedEmpty(vm.date.final))
      )
        vm.disabledSearchButton = true;
      if (
        vm.allowOnlyFinalDate &&
        !vm.testNullUndefinedEmpty(vm.date.final) &&
        vm.testNullUndefinedEmpty(vm.date.initial)
      )
        vm.disabledSearchButton = false;
    },

    sendDate() {
      const vm = this;
      vm.$emit("update-date", vm.date);
      vm.$nextTick(() => {
        vm.removeFocus();
      });
    },

    removeFocus() {
      document.activeElement.blur();
    },

    clearFields() {
      const vm = this;
      (vm.date = {
        initial: null,
        final: null,
      }),
        (vm.invalidFields = {
          dateFinal: false,
          dateInitial: false,
        }),
        (vm.disabledSearchButton = true),
        vm.$emit("update-date", vm.date);
      vm.$nextTick(() => {
        vm.removeFocus();
      });
    },
  },
};
</script>
<style lang="scss">
.search-by-date {
  background-color: rgb(243, 240, 240);
  border-radius: 10px;
  margin: 10px 10px 0px 0px !important;
  padding: 20px 40px 20px 20px !important;
  .search {
    margin-top: 40px;
    min-width: 40px;
  }
  .clear {
    margin-left: 10px;
  }
  .vs-input {
    .vs-con-input {
      background-color: white;
    }
  }
}
</style>
